module.exports = __webpack_public_path__ + "static/media/screen2.7a82da57.jpg";